import * as React from "react"
import "./image_and_blurb.scss"

const VideoSection = ({ right, headline, headlineBold, paragraph, buttonText, buttonHref, image  }) => {
  let imageOrder, contentOrder;
  right === true ? imageOrder = 'order-2' : imageOrder = 'order-1'
  right !== true ? contentOrder = 'order-2' : contentOrder = 'order-1'

  // reduces padding to 0 in-case of floating-webpage-image present(ie homepage) 
  let paddingTopContainer;
  buttonText === 'Our Customer Stories' ? paddingTopContainer = ' pt-0' : paddingTopContainer = '';

  return (
    <section class="video-section"> 
    <div id="image-and-blurb-container" className={"container image-and-blurb-container my-xl-3" + paddingTopContainer}>
      <div className={right === true ? 'image-right-row row row-cols-1 d-flex' : "row row-cols-1 d-flex"}>
        <div className={contentOrder + " col-md-12 col-lg-5 d-flex flex-column justify-content-md-center"} >
          <article>
          {/* <Headline regular={headline} bold={headlineBold} /> */}
          <i className="pt-3">"{headline} <strong>{headlineBold}</strong>"</i>
          {/* <Caption text={paragraph} /> */}
          <p className="py-2 caption">{paragraph}</p>
          {/* <BlueCTAButton text={buttonText} href={buttonHref} /> */}
          {buttonText? <a href={buttonHref}><button className="bg-primary blue-cta-button p-2 px-4 mt-2">{buttonText}</button></a> : null}
          </article>
        </div>
        <div className={imageOrder + " col-md-12 col-lg-6 offset-lg-1"} style={{ padding: "1rem" }}>
        <iframe src="https://fast.wistia.net/embed/iframe/1lafu09pmh?seo=true&videoFoam=true" title="Brede Ciapciak Dental Testimonial #3 Video" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no" className="wistia_embed" name="wistia_embed" msallowfullscreen width="100%" height="100%"></iframe>
<script src="https://fast.wistia.net/assets/external/E-v1.js" async></script>
        </div>
      </div>
    </div>
    </section>
  )
}

export default VideoSection